import { useEffect, useState } from 'react';

export const SCRIPT_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error',
};

export const useExternalScript = url => {
  let [state, setState] = useState(
    url ? SCRIPT_STATES.LOADING : SCRIPT_STATES.IDLE
  );

  useEffect(() => {
    if (!url) {
      setState(SCRIPT_STATES.IDLE);
      return;
    }

    let script = document.querySelector(`script[src="${url}"]`);

    const handleScript = e => {
      setState(e.type === 'load' ? SCRIPT_STATES.READY : SCRIPT_STATES.ERROR);
    };

    if (!script) {
      script = document.createElement('script');
      script.src = url;
      script.async = true;
      document.body.appendChild(script);
      script.addEventListener('load', handleScript);
      script.addEventListener('error', handleScript);
    }

    return () => {
      if (script) {
        script.removeEventListener('load', handleScript);
        script.removeEventListener('error', handleScript);
      }
    };
  }, [url]);

  return state;
};

export const useGTM = ({ gtmId, path } = {}) => {
  const [gtmUrl, setGtmUrl] = useState('');
  const [customScriptUrl, setCustomScriptUrl] = useState('');

  const gtmStatus = useExternalScript(gtmUrl);
  const customScriptStatus = useExternalScript(customScriptUrl);

  useEffect(() => {
    window['dataLayer'] = window['dataLayer'] || []; // initialyze data layer
  }, []);

  useEffect(() => {
    if (gtmId) {
      setGtmUrl(`https://www.googletagmanager.com/gtm.js?id=${gtmId}`);
    }
  }, [gtmId]);

  useEffect(() => {
    if (gtmStatus === SCRIPT_STATES.READY) {
      window['dataLayer'].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
    }

    if (!gtmId && path) {
      setCustomScriptUrl(path);
    } else if (
      gtmId &&
      (gtmStatus === SCRIPT_STATES.READY ||
        gtmStatus === SCRIPT_STATES.ERROR) &&
      path
    ) {
      setCustomScriptUrl(path);
    }
  }, [gtmStatus, path, gtmId]);

  return customScriptStatus;
};
